<div class="p-16">
  <trip-booking-package-header icon="edit_note">
    <ng-container ngProjectAs="[title]" >
      <span>Modifica post vendita: </span>
      @if (tripBookingPackage.target_info?.changeDetail?.changeType == 'traveller_change') {
        <span>Cambio Nominativo</span>
      }
      @if (tripBookingPackage.target_info?.changeDetail?.changeType == 'edit-date-time') {
        <span>Cambio Data/ora viaggio</span>
      }
      @if (tripBookingPackage.target_info?.changeDetail?.changeType == 'refund') {
        <span>Rimborso</span>
      }
      @if (tripBookingPackage.target_info?.changeDetail?.changeType == 'travel-change') {
        <span>Cambio Biglietto</span>
      }
      @if (tripBookingPackage.target_info?.changeDetail?.changeType == 'change-class') {
        <span>Cambio Classe</span>
      }
    </ng-container>

    <ng-container ngProjectAs="[sub-title-1]">
      @if (tripBookingPackage.created_at) {
        <span class="font-size-14 secondary-text">In data: {{ tripBookingPackage.created_at | date: 'dd/MM/yyyy HH:mm' }}</span>
      }
    </ng-container>
  </trip-booking-package-header>
</div>